export default __webpack_public_path__ + "static/media/selco_builders.d4faa0bf.png";